import { render, staticRenderFns } from "./slide-bar.vue?vue&type=template&id=3a4009fa&scoped=true"
import script from "./slide-bar.vue?vue&type=script&lang=js"
export * from "./slide-bar.vue?vue&type=script&lang=js"
import style0 from "./slide-bar.vue?vue&type=style&index=0&id=3a4009fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4009fa",
  null
  
)

export default component.exports